module.exports = __webpack_public_path__ + "img/order_heart.5d70196d.png";